import classNames from 'classnames';

import styles from '../../../styles/icons/base.module.scss';

interface CircleFacebookProps {
    color?: string;
    className?: string;
}

function CircleFacebook({ color = 'currentColor', className = null }: CircleFacebookProps) {
    return (
        <svg
            className={classNames([styles.container, { [className]: className !== null }])}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="19.879"
            viewBox="0 0 20 19.879"
        >
            <path
                d="M20.563,10.563A10,10,0,1,0,9,20.442V13.453H6.46V10.563H9v-2.2a3.528,3.528,0,0,1,3.777-3.89,15.39,15.39,0,0,1,2.239.2v2.46H13.754a1.445,1.445,0,0,0-1.629,1.562v1.877H14.9l-.444,2.891h-2.33v6.988A10,10,0,0,0,20.563,10.563Z"
                transform="translate(-0.563 -0.563)"
                fill={color}
            />
        </svg>
    );
}

export default CircleFacebook;
